import React from 'react';
import { Award, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import teamImage from '../assets/business-meeting.jpg';
import africanBusinessman from '../assets/african-man-black-suit_1157-45575.jpg_rbjcix.jpg';

const About = () => {



  return (
    <section id="about" className="relative pt-8 md:pt-12 lg:pt-16 pb-16 overflow-hidden" style={{
      background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.05) 0%, rgba(255, 255, 255, 1) 20%, rgba(249, 250, 251, 1) 100%)'
    }}>
      {/* Enhanced Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Top gradient overlay */}
        <div className="absolute top-0 left-0 w-full h-48" style={{
          background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.15) 0%, rgba(15, 23, 42, 0.05) 50%, transparent 100%)'
        }}></div>
        
        {/* Large decorative circles */}
        <div className="absolute top-16 lg:top-24 -left-32 w-64 h-64 rounded-full opacity-30" style={{
          background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, rgba(59, 130, 246, 0.02) 70%, transparent 100%)'
        }}></div>
        <div className="absolute top-32 lg:top-40 -right-24 w-56 h-56 rounded-full opacity-25" style={{
          background: 'radial-gradient(circle, rgba(30, 41, 59, 0.08) 0%, rgba(30, 41, 59, 0.02) 70%, transparent 100%)'
        }}></div>
        
        {/* Geometric pattern overlay */}
        <div className="absolute top-0 left-0 w-full h-full opacity-5" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%233b82f6' fill-opacity='0.4'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
        
        {/* Additional decorative elements */}
        <div className="absolute top-64 lg:top-80 left-1/4 w-32 h-32 rounded-full border-2 border-blue-200 opacity-20"></div>
        <div className="absolute top-96 lg:top-112 right-1/3 w-24 h-24 rounded-full border border-navy-200 opacity-15"></div>
        
        {/* Subtle grid pattern */}
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'linear-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(59, 130, 246, 0.1) 1px, transparent 1px)',
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header - No "About Us" tag, seamless content */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-serif text-navy-900 mb-6">
            Your Trusted
            <span className="text-gradient block">Financial Partner</span>
          </h2>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
          {/* Text Content */}
          <div data-aos="fade-right" data-aos-delay="100">
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              <strong className="text-navy-900">COREVEST</strong> is a leading financial services firm dedicated to helping individuals and businesses achieve their financial goals. We deliver comprehensive investment solutions and financial planning services with a commitment to transparency, security, and excellence.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our seasoned team combines deep expertise in investment management, financial planning, and strategic advisory services to offer a comprehensive suite of products and services. Whether you're seeking growth, security, or diversification, COREVEST is here to help you reach your financial goals with confidence.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Explore how our <span className="text-gold-500 font-semibold">expert financial guidance and innovative approach</span> can help you achieve your 
              investment objectives with confidence.
            </p>

            {/* Learn More Button */}
            <div>
              <Link
                to="/about"
                className="inline-flex items-center px-8 py-4 bg-gold-600 hover:bg-gold-700 text-white font-semibold rounded-xl transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl group"
              >
                Learn More About Us
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
              </Link>
            </div>

          </div>

          {/* Image */}
          <div className="relative" data-aos="fade-left" data-aos-delay="200">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src={teamImage}
                alt="COREVEST Team"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/50 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-xl p-6 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
              <div className="flex items-center space-x-4">
                <img
                  src={africanBusinessman}
                  alt="CEO"
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div>
                  <h5 className="font-semibold text-navy-900">Expert Leadership</h5>
                  <p className="text-sm text-gray-600">10+ Years Experience</p>
                  <div className="flex items-center mt-1">
                    {[...Array(5)].map((_, i) => (
                      <Award key={i} className="h-3 w-3 text-gold-500 fill-current" />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </div>
      
      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-20" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <defs>
            <linearGradient id="aboutWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{stopColor: '#f8fafc', stopOpacity: 1}} />
              <stop offset="50%" style={{stopColor: '#f1f5f9', stopOpacity: 1}} />
              <stop offset="100%" style={{stopColor: '#e2e8f0', stopOpacity: 1}} />
            </linearGradient>
          </defs>
          <path 
            d="M0,0 C150,100 350,0 600,50 C850,100 1050,0 1200,40 L1200,120 L0,120 Z" 
            fill="url(#aboutWaveGradient)"
          />
        </svg>
      </div>
    </section>
  );
};

export default About; 